<div class="merlin-header row">
  <header class="col-xs-10">
    <div [id]="identifierService.labelId('emergencyContactPopup', 'headerTitle')" class="simple-text wrap-text">
      {{ patientName ? patientName : patientIdForTitle ? patientIdForTitle : '' }} - {{ translate('label.gb.emergency_contact') }}
    </div>
  </header>
  <!-- <mat-icon class="col-xs-offset-1 col-xs-1 closeIcon" matRipple [mat-dialog-close]="true">close</mat-icon> -->
</div>
<h6 [id]="identifierService.labelId('emergency-contact-popup', 'emergencyContact')" mat-dialog-title [innerHTML]="translate('label.gb.emergency_contact') | safe: 'html'"></h6>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="emergencyForm">
    @if (data?.emerShowPhysicianOpt) {
      <div class="row merlin-row-styl checkbox-row">
        <ng-container>
          <div class="col-xs-1"></div>
          <div class="col-xs-9 pt-5">
                    <mat-checkbox formControlName="notifyEmergencyContactFlg" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'prefCntctMthd'
                        )
                    " [(ngModel)]="togglePhone" [checked]="emergencyForm.value.notifyEmergencyContactFlg" (change)="onNotifyemrConFlgChange($event)" data-tx-key="label.gb.pref_cntct_mthd">{{ translate('label.gb.pref_cntct_mthd') }}
            </mat-checkbox>
          </div>
        </ng-container>
      </div>
    }
    <div class="row merlin-row-styl checkbox-row">
      <div class="col-xs-10 col-xs-offset-1 row">
        @if (togglePhone) {
          <span>*</span>
        }
        <label [id]="identifierService.labelId('emergencyContactPopup', 'phone')" class="phone_label" data-tx-key="label.gb.home_phone">{{
          'label.gb.home_phone' | translate
        }}</label>
      </div>
    </div>
    <div class="row merlin-row-styl mb-10">
      <div class="col-xs-10 col-xs-offset-1 row phone-row">
        <div class="phone-styl col-xs-3 CCnAC phone-col col-a" style="padding-left: 0px">
          <mat-form-field class="merlin-select bgAdjust" [formGroup]="phoneGrp" appearance="outline">
                        <input matInput formControlName="countryCode" maxlength="3" [required]="togglePhone" [id]="
                                identifierService.dropdownId(
                                    'emergency-contact-popup',
                                    'countryCode'
                                )
                            " />
              <mat-hint class="countryCode" data-tx-key="label.gb.phone_country_code">{{ 'label.gb.phone_country_code' | translate }}
              </mat-hint>
            </mat-form-field>
          </div>
          <div class="phone-styl col-xs-3 CCnAC phone-col col-b" style="padding-left: 0;">
            <mat-form-field class="merlin-select bgAdjust em-areaCode" [formGroup]="phoneGrp" appearance="outline">
                        <input matInput formControlName="areaCode" maxlength="5" [required]="togglePhone" [id]="
                                identifierService.dropdownId(
                                    'emergency-contact-popup',
                                    'areaCode'
                                )
                            " />
                <mat-hint class="word-wrap" data-tx-key="label.gb.phone_area_code">{{ 'label.gb.phone_area_code' | translate }}
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="number-style col-xs-6 phone-col col-c" style="padding-left: 0; padding-right: 0">
              <mat-form-field class="merlin-select phoneField" [formGroup]="phoneGrp" appearance="outline">
                        <input matInput formControlName="number" maxlength="12" [required]="togglePhone" [id]="
                                identifierService.dropdownId(
                                    'emergency-contact-popup',
                                    'number'
                                )
                            " />
                  <mat-hint class="phoneHint" data-tx-key="label.gb.phone_number">{{ 'label.gb.phone_number' | translate }}
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="30" [groupName]="emergencyForm" label="{{ 'label.gb.firstname' | translate }}" placeHolder="{{ 'label.gb.firstname' | translate }}" [required]="false" controlName="firstName" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'firstName'
                        )
                    " data-tx-key="label.gb.firstname">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="30" [groupName]="emergencyForm" label="{{ 'label.gb.lastname' | translate }}" placeHolder="{{ 'label.gb.lastname' | translate }}" [required]="false" controlName="lastName" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'lastName'
                        )
                    " data-tx-key="label.gb.lastname">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="100" [groupName]="emergencyForm" label="{{ 'label.gb.address1' | translate }}" placeHolder="{{ 'label.gb.address1' | translate }}" [required]="false" controlName="address" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'address'
                        )
                    " data-tx-key="label.gb.address1">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="100" [groupName]="emergencyForm" label="{{ 'label.gb.address2' | translate }}" placeHolder="{{ 'label.gb.address2' | translate }}" [required]="false" controlName="address2" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'address2'
                        )
                    " data-tx-key="label.gb.address2">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="100" [groupName]="emergencyForm" label="{{ 'label.gb.address3' | translate }}" placeHolder="{{ 'label.gb.address3' | translate }}" [required]="false" controlName="address3" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'address3'
                        )
                    " data-tx-key="label.gb.address3">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
              <mat-form-field [formGroup]="emergencyForm" class="merlin-select mr-20 full-width" appearance="outline">
                <mat-label [id]="identifierService.labelId('emergencyContact', 'country')" data-tx-key="label.gb.country">{{ 'label.gb.country' | translate }}</mat-label>
                    <mat-select disableOptionCentering formControlName="countryCd" [compareWith]="compareCountry" (selectionChange)="countrySelection($event)" [id]="
                            identifierService.dropdownId(
                                'emergency-contact-popup',
                                'countryCodes'
                            )
                        ">
                  @for (
                    country of countryList
                    ; track
                    country) {
                    <mat-option [id]="identifierService.listitemId('emergency-contact-popup', 'countryOption_' + country?.codeId)" value="{{ country.codeId }}" [attr.data-tx-key]="country.txKey">{{ country?.label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row merlin-row-styl">
            @if (isSelectedUSACountry) {
              <div class="col-xs-10 col-xs-offset-1">
                <mat-form-field class="merlin-select mr-20 full-width" appearance="outline">
                  <mat-label [id]="identifierService.labelId('emergencyContact', 'stateProvince')" data-tx-key="label.gb.state_province">{{ 'label.gb.state_province' | translate }}
                  </mat-label>
                        <mat-select disableOptionCentering formControlName="stateCd" [compareWith]="compareCountry" [id]="
                                identifierService.dropdownId(
                                    'emergency-contact-popup',
                                    'stateCodes'
                                )
                            ">
                    @for (
                      state of emergencyContact?.dropdowns
                      ?.stateCodes
                      ; track
                      state) {
                      <mat-option [id]="identifierService.listitemId('emergency-contact-popup', 'stateOption_' + state?.codeId)" value="{{ state.codeId }}" [attr.data-tx-key]="'data.Code.State_Cd.Code_Desc.' + state.code">{{ 'data.Code.State_Cd.Code_Desc.' + state.code | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (!isSelectedUSACountry) {
              <div class="col-xs-10 col-xs-offset-1">
                    <merlin-textbox [groupName]="emergencyForm" controlName="state" label="{{ 'label.gb.state_province' | translate }}" maxLength="30" [id]="
                            identifierService.dropdownId(
                                'emergency-contact-popup',
                                'stateCodeText'
                            )
                        " data-tx-key="label.gb.state_province"></merlin-textbox>
              </div>
            }
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="30" [groupName]="emergencyForm" label="{{ 'label.gb.city' | translate }}" placeHolder="{{ 'label.gb.city' | translate }}" [required]="false" controlName="city" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'city'
                        )
                    " data-tx-key="label.gb.city">
              </merlin-textbox>
            </div>
          </div>
          <div class="row merlin-row-styl">
            <div class="col-xs-10 col-xs-offset-1">
                <merlin-textbox maxLength="30" [groupName]="emergencyForm" label="{{ 'label.gb.zip_post_code' | translate }}" placeHolder="{{ 'label.gb.zip_post_code' | translate }}" [required]="false" controlName="zipCode" [id]="
                        identifierService.dropdownId(
                            'emergency-contact-popup',
                            'zipCode'
                        )
                    " data-tx-key="label.gb.zip_post_code">
              </merlin-textbox>
            </div>
          </div>
          @if (viewMode()) {
            <div class="row merlin-row-styl">
              <div class="col-xs-10 col-xs-offset-1">
                <div [id]="identifierService.labelId('emergencyContactPopup', 'editModeNote')" class="cardText" data-tx-key="label.gb.edit_mode_note">
                  {{ 'label.gb.edit_mode_note' | translate }}
                </div>
              </div>
            </div>
          }
        </form>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close color="accent" (click)="close()" id="cancelPwdChange" [attr.data-tx-key]="viewMode() ? 'label.gb.close' : 'label.gb.button_cancel'">
          {{
          (viewMode() ? 'label.gb.close' : 'label.gb.button_cancel')
          | translate
          }}
        </button>
        @if (!viewMode()) {
          <button mat-button class="saveBtn" (click)="submit()" id="savePwdChange" data-tx-key="label.gb.save">
            {{ 'label.gb.save' | translate }}
          </button>
        }
      </mat-dialog-actions>
